import { createSlice } from '../wrappers';

export interface IModalSlice {
	modalNewsVisible: boolean;
	modalNewsId: string;
	modalOfferVisible: boolean;
	modalCaseDefaultVisible: boolean;
	modalCaseKitVisible: boolean;
	openCaseVisible: boolean;
	openCaseRewardVisible: boolean;
	modalSkillsVisible: boolean;
	modalChangeNameVisible: boolean;
	modalChangeNamePendingVisible: boolean;
	modalChangeNameRejectedVisible: boolean;
	modalBuyVisible: boolean;
}

const initialState: IModalSlice = {
	modalNewsVisible: false,
	modalNewsId: '',
	modalOfferVisible: false,
	modalCaseDefaultVisible: false,
	modalCaseKitVisible: false,
	openCaseVisible: false,
	openCaseRewardVisible: false,
	modalSkillsVisible: false,
	modalChangeNameVisible: false,
	modalChangeNamePendingVisible: false,
	modalChangeNameRejectedVisible: false,
	modalBuyVisible: false,
};

const modalSlice = createSlice({
	name: 'modal',
	initialState,
	reducers: {
		setModalNewsVisible: (state, action) => {
			state.modalNewsVisible = action.payload;
		},
		setModalOfferVisible: (state, action) => {
			state.modalOfferVisible = action.payload;
		},
		setModalCaseDefaultVisible: (state, action) => {
			state.modalCaseDefaultVisible = action.payload;
		},
		setModalCaseKitVisible: (state, action) => {
			state.modalCaseKitVisible = action.payload;
		},
		setOpenCaseVisible: (state, action) => {
			state.openCaseVisible = action.payload;
		},
		setOpenCaseRewardVisible: (state, action) => {
			state.openCaseRewardVisible = action.payload;
		},
		setModalNewsId: (state, action) => {
			state.modalNewsId = action.payload;
		},
		setModalSkillsVisible: (state, action) => {
			state.modalSkillsVisible = action.payload;
		},
		setModalChangeNameVisible: (state, action) => {
			state.modalChangeNameVisible = action.payload;
		},
		setModalChangeNamePendingVisible: (state, action) => {
			state.modalChangeNamePendingVisible = action.payload;
		},
		setModalChangeNameRejectedVisible: (state, action) => {
			state.modalChangeNameRejectedVisible = action.payload;
		},
		setModalBuyVisible: (state, action) => {
			state.modalBuyVisible = action.payload;
		},
		resetModalState: (state) => {
			state.modalNewsVisible = false;
			state.modalNewsId = '';
			state.modalOfferVisible = false;
			state.modalCaseDefaultVisible = false;
			state.modalCaseKitVisible = false;
			state.openCaseVisible = false;
			state.openCaseRewardVisible = false;
			state.modalSkillsVisible = false;
			state.modalChangeNameVisible = false;
			state.modalChangeNamePendingVisible = false;
			state.modalChangeNameRejectedVisible = false;
			state.modalBuyVisible = false;
		},
	},
});

export const {
	setModalNewsVisible,
	setModalOfferVisible,
	setModalCaseDefaultVisible,
	setModalCaseKitVisible,
	setOpenCaseVisible,
	setOpenCaseRewardVisible,
	setModalNewsId,
	setModalSkillsVisible,
	setModalChangeNameVisible,
	setModalChangeNamePendingVisible,
	setModalChangeNameRejectedVisible,
	setModalBuyVisible,
	resetModalState,
} = modalSlice.actions;

export default modalSlice.reducer;
